<template>
  <div class="book-promotion container-fluid py-5">
    <div v-if="isSingleBanner && selectedBanner">
      <!-- Single Banner -->
      <div class="row">
        <div class="col-md-12 pe-md-2 mb-3 mb-md-0">
          <a
            :href="`/search/?c=${selectedBanner.linkTo}`"
            class="promo-card-single"
            :style="{ backgroundImage: `url(${BASE_IMAGE_PREFIX}/${selectedBanner.imageUrl})` }"
            aria-label="Shop Now Weekend Deal"
          >
          </a>
        </div>
      </div>
    </div>
    <div v-else>
      <div v-if="banners.length" class="row">
        <div
          v-for="(banner, index) in banners"
          :key="`weekend-${index}`"
          class="col-md-6 pe-md-2 mb-3 mb-md-0"
        >
          <a
            :href="`/search/?c=${banner.linkTo}`"
            class="promo-card"
            :style="{ backgroundImage: `url(${BASE_IMAGE_PREFIX}/${banner.imageUrl})` }"
            aria-label="Shop Now Weekend Deal"
          >
          </a>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { BASE_IMAGE_PREFIX } from '@/globals';

export default {
  name: "PromotionBanner",
  props: {
    isSingleBanner: {
      type: Boolean,
      default: false,
    },
    banners: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      BASE_IMAGE_PREFIX,
    }
  },
  computed: {
    selectedBanner() {
      if (this.isSingleBanner) {
        const isMobile = window.innerWidth <= 992;
        const layout = isMobile ? "mobile" : "desktop";
        return this.banners.find((b) => b.layout === layout);
      }
      return null;
    },
  },
};
</script>

<style lang="scss">
.book-promotion {
  .promo-card-single {
    display: block;
    width: 100%;
    border-radius: 16px;
    overflow: hidden;
    background-size: cover;
    background-position: center;
    background-repeat: no-repeat;
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.05);
    transition: transform 0.3s ease;
    aspect-ratio: 5.3 / 1;

    &:hover {
      transform: scale(1.01);
    }
  }
  .promo-card {
    display: block;
    width: 100%;
    border-radius: 16px;
    overflow: hidden;
    background-size: cover;
    background-position: center;
    background-repeat: no-repeat;
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.05);
    transition: transform 0.3s ease;
    aspect-ratio: 16 / 9;

    &:hover {
      transform: scale(1.01);
    }
  }
}
@media (max-width: 991px) {
  .book-promotion {
    .promo-card-single {
      aspect-ratio: 1.9 / 1;
    }
  }
}
</style>
